import Vue from 'vue'
import VueRouter from 'vue-router'
import BasicLayout from '../views/layouts/basic_layout.vue'

Vue.use(VueRouter)

export const constantRoutes = [
  {
    path: '/',
    redirect: '/user/login'
  },
  // 登录页面
  {
    path: '/user/login',
    name: 'Login',
    component: () => import(/* webpackChunkName:"Login" */ '../views/login/login.vue')
  },
  {
    path: '*',
    component: () => import(/* webpackChunkName:"404" */ '../views/error/404.vue')
  },
  {
    path: '/',
    component: BasicLayout,
    children: [
      {
        path: '/home',
        name: 'Home',
        meta: { title: '首页轮播图' },
        component: () => import(/* webpackChunkName:"Home" */ '../views/banner/index.vue')
      },
      // 首页轮播图
      // {
      //   path: '/banner',
      //   name: 'Banner',
      //   meta: { title: '首页轮播图' },
      //   component: () => import(/* webpackChunkName:"Banner" */ '../views/banner/index.vue')
      // },

      // 轮播图管理 - 新增
      {
        path: '/banner-manage-add',
        name: 'BannerManageAdd',
        meta: { title: '首页轮播图新增' },
        component: () => import(/* webpackChunkname:"BannerManageAdd" */ '../views/banner/banner-add.vue')
      },
      // 轮播图管理 - 编辑
      {
        path: '/banner-manage-edit',
        name: 'BannerManageEdit',
        meta: { title: '首页轮播图编辑' },
        component: () => import(/* webpackChunkname:"BannerManageEdit" */ '../views/banner/banner-add.vue')
      },
      // {
      //   path: '/banner-manage-edit/:id',
      //   name: 'BannerManageEdit',
      //   meta: { title: '首页轮播图编辑' },
      //   component: () => import(/* webpackChunkname:"BannerManageEdit" */ '../views/banner/banner-add.vue')
      // },
      // 大事记列表
      {
        path: '/big-event',
        name: 'BigEvent',
        meta: { title: '大事记列表' },
        component: () => import(/* webpackChunkName:"BigEvent" */ '../views/big-event/index.vue')
      },
      // 大事记 新建页面
      {
        path: '/big-event-add',
        name: 'BigEventAdd',
        meta: { title: '大事记新增' },
        component: () => import(/* webpackChunkName:"BigEventAdd" */ '../views/big-event/big-event-edit.vue')
      },
      // 大事记 编辑页面
      {
        path: '/big-event-edit',
        name: 'BigEventEdit',
        meta: { title: '大事记编辑' },
        component: () => import(/* webpackChunkName:"BigEventEdit" */ '../views/big-event/big-event-edit.vue')
      },
      // {
      //   path: '/big-event-edit/:id',
      //   name: 'BigEventEdit',
      //   meta: { title: '大事记编辑' },
      //   component: () => import(/* webpackChunkName:"BigEventEdit" */ '../views/big-event/big-event-edit.vue')
      // },
      // 学会活动
      {
        path: '/society-activity',
        name: 'SocietyActivity',
        meta: { title: '学会活动' },
        component: () => import(/* webpackChunkName:"SocietyActivity" */ '../views/society-activity/index.vue')
      },
      // 学会活动 新建页面
      {
        path: '/society-activity-add',
        name: 'SocietyActivityAdd',
        meta: { title: '学会活动新增' },
        component: () => import(/* webpackChunkName:"SocietyActivityAdd" */ '../views/society-activity/societyActivityEdit.vue')
      },
      // 学会活动 编辑页面
      {
        path: '/society-activity-edit',
        name: 'SocietyActivityEdit',
        meta: { title: '学会活动编辑' },
        component: () => import(/* webpackChunkName:"SocietyActivityEdit" */ '../views/society-activity/societyActivityEdit.vue')
      },

      // {
      //   path: '/society-activity-edit/:id',
      //   name: 'SocietyActivityEdit',
      //   meta: { title: '学会活动编辑' },
      //   component: () => import(/* webpackChunkName:"SocietyActivityEdit" */ '../views/society-activity/societyActivityEdit.vue')
      // },

      // 辞书培训班
      {
        path: '/dictionary-train',
        name: 'DictionaryTrain',
        meta: { title: '辞书培训班' },
        component: () => import(/* webpackChunkName:"DictionaryTrain" */ '../views/dictionary-train-course/index.vue')
      },
      // 辞书培训班 - 新增
      {
        path: '/dictionary-train-add',
        name: 'DictionaryTrainAdd',
        meta: { title: '辞书培训班新增' },
        component: () => import(/* webpackChunkName:"DictionaryTrainAdd" */ '../views/dictionary-train-course/trainCourseEdit.vue')
      },
      // 辞书培训班 - 编辑
      {
        path: '/dictionary-train-edit',
        name: 'DictionaryTrainEdit',
        meta: { title: '辞书培训班编辑' },
        component: () => import(/* webpackChunkName:"DictionaryTrainEdit" */ '../views/dictionary-train-course/trainCourseEdit.vue')
      },
      // 培训班报名表
      {
        path: '/dictionary-train-apply',
        name: 'TrainCourseApply',
        meta: { title: '培训班报名表' },
        component: () => import(/* webpackChunkName:"TrainCourseApply" */ '../views/dictionary-train-course/trainCourseApply.vue')
      },
      // 培训班报名表 新增编辑
      {
        path: '/dictionary-train-apply-edit',
        name: 'TrainCourseApplyEdit',
        meta: { title: '培训班报名表编辑' },
        component: () => import(/* webpackChunkName:"TrainCourseApplyEdit" */ '../views/dictionary-train-course/trainCourseApplyEdit.vue')
      },
      // 培训班报名表 新增编辑 +id
      // {
      //   path: '/dictionary-train-apply-edit:id',
      //   name: 'TrainCourseApplyEdit',
      //   meta: { title: '培训班报名表编辑' },
      //   component: () => import(/* webpackChunkName:"TrainCourseApplyEdit" */ '../views/dictionary-train-course/trainCourseApplyEdit.vue')
      // },

      // 辞书世界 - 纸质辞书管理
      {
        path: '/dictionaries-management',
        name: 'DictionaryManage',
        meta: { title: '纸质辞书管理' },
        component: () => import(/* webpackChunkname:"DictionaryManage" */ '../views/institute-world/dictionaries-management')
      },
      // 辞书世界 -纸质新增
      {
        path: '/dictionaries-management-add',
        name: 'DictionaryManageAdd',
        meta: { title: '纸质辞书新增' },
        component: () => import(/* webpackChunkName:"DictionaryManageAdd" */ '../views/institute-world/dictionaries-management/dictionaryManageEdit.vue')
      },
      // 辞书世界 -纸质编辑
      {
        path: '/dictionaries-management-edit',
        name: 'DictionaryManageEdit',
        meta: { title: '纸质辞书编辑' },
        component: () => import(/* webpackChunkName:"DictionaryManageEdit" */ '../views/institute-world/dictionaries-management/dictionaryManageEdit.vue')
      },
      // 辞书世界 - 数字/融媒管理页
      {
        path: '/digital-media',
        name: 'DigitalMedia',
        meta: { title: '融媒辞书' },
        component: () => import(/* webpackChunkname:"DigitalMedia" */ '../views/institute-world/digital-media')
      },
      // 辞书世界 - 数字/融媒管理页-新增
      {
        path: '/dictionaries-digital-media-add',
        name: 'DictionaryDigitalAdd',
        meta: { title: '融媒辞书新增' },
        component: () => import(/* webpackChunkName:"DictionaryDigitalAdd" */ '../views/institute-world/digital-media/dicitonaryMediaEdit.vue')
      },
      // 辞书世界 - 数字/融媒管理页-编辑
      {
        path: '/dictionaries-digital-media-edit',
        name: 'DictionaryDigitalEdit',
        meta: { title: '融媒辞书编辑' },
        component: () => import(/* webpackChunkName:"DictionaryDigitalEdit" */ '../views/institute-world/digital-media/dicitonaryMediaEdit.vue')
      },

      // 品牌辞书
      {
        path: '/brand-dictionary',
        name: 'BrandDictionary',
        meta: { title: '品牌辞书' },
        component: () => import(/* webpackChunkName:"BrandDictionary" */ '../views/brand-dictionary/index.vue')
      },
      // 品牌辞书 -新增
      {
        path: '/brand-dictionary-add',
        name: 'BrandDictionaryAdd',
        meta: { title: '品牌辞书新增' },
        component: () => import(/* webpackChunkName:"BrandDictionaryAdd" */ '../views/brand-dictionary/brandDictionaryEdit.vue')
      },
      // 品牌辞书 -编辑
      {
        path: '/brand-dictionary-edit',
        name: 'BrandDictionaryEdit',
        meta: { title: '品牌辞书编辑' },
        component: () => import(/* webpackChunkName:"BrandDictionaryEdit" */ '../views/brand-dictionary/brandDictionaryEdit.vue')
      },
      // 辞书研究
      {
        path: '/dictionary-research',
        name: 'DictionaryResearch',
        meta: { title: '辞书研究' },
        component: () => import(/* webpackChunkName:"DictionaryResearch" */ '../views/dictionary-research')
      },
      // 辞书研究 - 新增
      {
        path: '/dictionary-research-add',
        name: 'DictionaryResearchAdd',
        meta: { title: '辞书研究新增' },
        component: () => import(/* webpackChunkName:"DictionaryResearchAdd" */ '../views/dictionary-research/dictionaryResearchEdit.vue')
      },
      // 辞书研究 - 编辑
      {
        path: '/dictionary-research-edit',
        name: 'DictionaryResearchEdit',
        meta: { title: '辞书研究编辑' },
        component: () => import(/* webpackChunkName:"DictionaryResearchEdit" */ '../views/dictionary-research/dictionaryResearchEdit.vue')
      },
      // 辞书研究 - 期刊文章
      {
        path: '/dictionary-magazine',
        name: 'DictionaryMagazine',
        meta: { title: '期刊文章' },
        component: () => import(/* webpackChunkName:"DictionaryMagazine" */ '../views/dictionary-research/magazine')
      },
      // 辞书研究 - 期刊文章 新增
      {
        path: '/dictionary-magazine-add',
        name: 'DictionaryMagazineAdd',
        meta: { title: '期刊文章新增' },
        component: () => import(/* webpackChunkName:"DictionaryMagazineAdd" */ '../views/dictionary-research/magazine/magazineListEdit.vue')
      },
      // 辞书研究 - 期刊文章 编辑
      {
        path: '/dictionary-magazine-edit',
        name: 'DictionaryMagazineEdit',
        meta: { title: '期刊文章编辑' },
        component: () => import(/* webpackChunkName:"DictionaryMagazineEdit" */ '../views/dictionary-research/magazine/magazineListEdit.vue')
      },
      // 邮箱列表
      {
        path: '/email',
        name: 'Email',
        meta: { title: '邮箱列表' },
        component: () => import(/* webpackChunkName:"Email" */ '../views/email')

      }

    ]
  }
]

export default new VueRouter({
  routes: constantRoutes
})
